export const INFO = 'info';
export const DEFAULT = 'default';
export const ERROR = 'error';
export const ALERT = 'alert';
export const SUCCESS = 'success';

export type ToastStyleType = 'info' | 'success' | 'error' | 'alert' | 'default';
export type ToastIconType = 'information-circle' | 'x-circle' | 'exclamation' | 'check-circle';

export type ToastPropsType = {
  index: number;
  toast: ToastType;
};

export interface TypeToastIcon {
  [key: string]: ToastIconType;
}
export const ToastIcon: TypeToastIcon = {
  [INFO]: 'information-circle',
  [DEFAULT]: 'information-circle',
  [ERROR]: 'x-circle',
  [ALERT]: 'exclamation',
  [SUCCESS]: 'check-circle',
};

export type ToastType = { body: string; type: ToastStyleType; id?: string; isMobile?: boolean };
